import {rules as v} from '../scripts/rules';

/* 2021-03-15  So sähe laut Kunden eine korrekte CSV aus
Profilnr;Befundnr;Fotonr;Notiz;Datum;Bearbeiter
Zahl;Zahl(en);Zahl(en);Text in "";tt.mm.jjjj;Name
*/

const profilliste = {
	"Profilnr"    : v.isNum,
	//"Schnittnr"   : v.isNum,
	//"Planumsnr"   : v.isNumManyWithoutDash,
	"Befundnr"    : v.isNumManyWithoutDash,
	"Fotonr"      : v.isNumManyWithoutDash,
	"Notiz"       : v.isFreetext,
	"Datum"       : v.isDate,
	"Bearbeiter"  : v.isFreetextNotEmpty,
	//"Verworfen"   : v.isJN,
}
/*
const profilliste = {
	"Profilnr"    : v.isNum,
	//"Schnittnr"   : v.isNum,
	//"Planumsnr"   : v.isNumManyWithoutDash,
	"Befundnr"    : v.isNumManyWithoutDash,
	"Beschreibung": v.isFreetext,
	"Fotonr"      : v.isNumManyWithoutDash,
	"Datum"       : v.isDate,
	"BearbeiterIn": v.isFreetextNotEmpty,
	"Verworfen"   : v.isJN,
}
*/

export default profilliste;
